export default __webpack_public_path__ + "static/media/feature-4.166012e9.svg";